import { ChangeDetectorRef, Component, HostListener, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { RestApiService } from '../rest-api.service';
import { MessageService } from '../message.service';
import { ActivatedRoute, NavigationEnd, NavigationError, NavigationStart, Router } from '@angular/router';
import { MediaMatcher } from '@angular/cdk/layout';
import { Subscription } from 'rxjs';
import { NotifierService } from 'angular-notifier';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SocketService } from '../socket.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-navbar-lt',
    templateUrl: './navbar-lt.component.html',
    styleUrls: ['./navbar-lt.component.css']
})
export class NavbarLtComponent implements OnInit, OnDestroy {

    public opened = false;
    public isLanCollapsed = true;
    navbar = [];
    public userName: string;
    mobileQuery: MediaQueryList;
    private notifier: NotifierService;
    respObject: any;
    // private eventUrl: string;
    private _mobileQueryListener: () => void;
    clientId: number;
    navLoaded = true;
    roleName: string;
    roleId : number;
    private tokenService: Subscription;
    copyYear: number;
    clientName: string;
    private userAuth: Subscription;
    @ViewChild('content') myModal: any;
    Newpassword: string;
    confirmpassword: string;
    password: string;
    dialogRef: any;
    clientLogo: string;


    constructor(private _rest: RestApiService, public dialog: MatDialog, private messageService: MessageService,
        private actRoute: ActivatedRoute, private route: Router, changeDetectorRef: ChangeDetectorRef,
        media: MediaMatcher, private socketService: SocketService, notifier: NotifierService) {
        this.notifier = notifier;

        this.mobileQuery = media.matchMedia('(max-width: 600px)');
        this._mobileQueryListener = () => changeDetectorRef.detectChanges();
        this.mobileQuery.addListener(this._mobileQueryListener);
        // this.messageService.clientId = undefined;
        // location.onPopState(() => {
        //
        //   console.log('pressed back!');
        //   // window.history.go(-1);
        // });
        // console.log(' routing ---');
        this.tokenService = this.messageService.tokenSubject.subscribe(() => {
            // if (this.messageService.getUserId() === null) {
            // console.log('-------- inside token -------------');
            this.getRoleAndDetails();
            // }
        });
        route.events.subscribe((event) => {

            if (event instanceof NavigationStart) {
                // Show loading indicator
                // console.log('NavigationStart');
            }

            if (event instanceof NavigationEnd) {
                // console.log('end : ' + JSON.stringify(event));
                // console.log('NavigationEnd');
                // this.eventUrl = event.url;
                // this.messageService.getModules();
                //  console.log(JSON.stringify(window.location.href));

                // Hide loading indicator
            }

            if (event instanceof NavigationError) {
                // Hide loading indicator
                // Present error to user
                // console.log(event.error);
            }
        });
    }

    changeToDashboard() {
        // this.route.navigate(['ticket/dashboard']);
        if (this.messageService.dashboardUrl !== undefined && this.messageService.dashboardUrl !== null) {
            this.messageService.changeRouting(this.messageService.dashboardUrl);
        }
    }

    getRoleAndDetails() {
        this.navLoaded = false;
        this._rest.getRoleUserActionMapping({ user_id: this.messageService.getUserId(), url: window.location.href }).subscribe((res) => {
            this.respObject = res;
            if (this.respObject.success) {
                // console.log(JSON.stringify(this.respObject));
                this.userName = this.respObject.details.name;
                this.clientId = this.respObject.details.clientId;
                this.messageService.setClientId(this.clientId);

                // this.respObject.details.actionDtls[0].clientId = this.respObject.details.clientId;
                this.roleName = this.respObject.details.actionDtls[0].roleName;
                this.roleId = this.respObject.details.actionDtls[0].roleId;
                this.messageService.setUserRole(this.roleName);                
                this.messageService.setUserRoleid(this.roleId);
                const isAdmin = this.respObject.details.actionDtls[0].isAdmin;
                const userGroups = this.respObject.details.actionDtls[0].groupId;
                this.socketService.userRoomJoin(this.messageService.getUserId());
                this.clientName = this.respObject.details.actionDtls[0].client;
                this.clientLogo = this.respObject.details.actionDtls[0].logo;
                const urls = this.respObject.details.urls;
                for (let i = 0; i < urls.length; i++) {
                    if (urls[i].name === 'logout') {
                        this.messageService.logOutUrl = urls[i].url;
                    }
                    if (urls[i].name === 'search') {
                        this.messageService.searchUrl = urls[i].url;
                    }
                    if (urls[i].name === 'dashboard' && urls[i].isAdmin === isAdmin) {
                        this.messageService.dashboardUrl = urls[i].url;
                    }
                    if (urls[i].name === 'faq') {
                        this.messageService.faqUrl = urls[i].url;
                    }
                    if ( urls[i].name === 'bulkAssigment'){
                        this.messageService.bulkAssigmentUrl = urls[i].url;
                    }
                    if ( urls[i].name === 'ReAssigment'){
                        this.messageService.reassigmentUrl = urls[i].url;
                    }
                    if (urls[i].name === 'createTicket') {
                        this.messageService.createUrl = urls[i].url;
                    }
                    if (urls[i].name === 'viewTicket') {
                        this.messageService.viewUrl = urls[i].url;
                    }
                    if (urls[i].name === 'ScheduleTicket') {
                        this.messageService.scheduleTicketUrl = urls[i].url;
                    }
                    if (urls[i].name === 'Group Mapping') {
                        this.messageService.groupMapUrl = urls[i].url;
                    }
                }
                if (userGroups !== undefined) {
                    for (let i = 0; i < userGroups.length; i++) {
                        this.socketService.groupRoomJoin(userGroups[i].groupId);
                    }
                }
                this.navLoaded = false;
                this._rest.getDynamicMenuDtls(this.clientId, this.messageService.getUserId()).subscribe((res1) => {
                    this.respObject = res1;
                    if (this.respObject.success) {
                        this.navbar = this.respObject.details;
                        // this.navbar[0]['imageIcon'] = '/assets/img/attachment-clip.png';
                        this.navLoaded = true;
                    } else {
                    }
                }, (err) => {

                });
                this.messageService.setClientUserAuth(this.respObject.details.actionDtls);
                // this.messageService.setUserAuth(this.respObject.details.actionDtls);
            } else {
                alert(this.respObject.errorMessage);
                this.messageService.logOut();
            }
        }, (err) => {

        });
    }

    ngOnInit() {
        this.copyYear = new Date().getFullYear();
        this.actRoute.queryParams.subscribe(params => {
            const token = params['token'];
            const client = params['clientId'];
            console.log('Navbar == >> client ' + client)
            if (client === undefined && token === undefined) {
                if (this.messageService.getUserId() !== null) {
                    console.log('-------- inside userid -------------');
                    this.getRoleAndDetails();
                }
            } else {
                this.messageService.setClientId(client);
            }
        });
        const dropdowns = document.getElementById('userDetails');
        dropdowns.style.display = 'none';
        window.addEventListener('click', function (event) {
            if (!(<HTMLInputElement>event.target).matches('.drop-btn')) {
                dropdowns.style.display = 'none';
            }
        });
    }

    ngOnDestroy(): void {
        this.mobileQuery.removeListener(this._mobileQueryListener);
        if (this.tokenService) {
            this.tokenService.unsubscribe();
        }
        if (this.userAuth) {
            this.userAuth.unsubscribe();
        }
    }

    langCollapse() {
        this.isLanCollapsed = !this.isLanCollapsed;
    }

    userCollapse() {
        this.isLanCollapsed = true;
        const x = document.getElementById('userDetails');
        if (x.style.display === 'none') {
            x.style.display = 'block';
        } else {
            x.style.display = 'none';
        }
    }

    changeRouting(path: string) {
        this.messageService.changeRouting(path);
    }


    signOut() {
        // this.messageService.clearSession();
        // window.location.href = this.messageService.API_ROOT;
        this.messageService.logOut();
    }

    change_password() {
        this.dialogRef = this.dialog.open(this.myModal, {});
    }

    submit() {
        const pattern = /^[a-zA-Z0-9!@#$%^&*]{8,20}$/;
        if (!this.Newpassword.match(pattern)) {
            this.notifier.notify('error', ' Invalid Password ');
        } else {
            if (this.Newpassword === this.confirmpassword) {
                // alert('matched');
                const data = {
                    password: this.password,
                    newPassword: this.confirmpassword,
                    clientId: this.clientId
                };
                // console.log('================'+JSON.stringify(data));
                this._rest.PasswordChange(data).subscribe((res1) => {
                    this.respObject = res1;
                    if (this.respObject.success) {

                        alert('To make sure your account\'s secure ,we can log you out of any other devices, ' +
                            'you can log back in with your New Password');
                        // this.notifier.notify('success','Password changed');
                        this.messageService.logOut();
                        // console.log('============================= > password changed')
                    } else {
                        this.notifier.notify('error', this.respObject.errorMessage);
                    }
                }, (err) => {
                    this.notifier.notify('error', this.messageService.SERVER_ERROR);
                });


            } else {
                this.notifier.notify('error', 'New Password and Confirm Password are not matched');
            }
        }

    }

    onNoClick() {
        this.dialogRef.close();
    }

}
